import React from 'react';
import styled from 'styled-components';
import { theme } from '..';
import Icon from '../Icon';
import Textinput from '../Textinput';

const TextFieldWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  
  .MuiTextField-root {
    margin: 0;
    div { border-radius: 10px; }
  }
`;

const IconCloseStyled = styled(Icon.Close)`
  cursor: pointer;
`;

const SearchBar = ({ handleClear, handleSearch, inputRef, placeholder, value }) => {
  const controlledProps = value !== undefined ? { value } : {};
  return (
    <TextFieldWrapper>
      <Textinput
        placeholder={placeholder}
        variant='outlined'
        onChange={handleSearch}
        inputRef={inputRef}
        startIcon={<Icon.Search color={theme.colors.NEU_600} />}
        endIcon={<IconCloseStyled onClick={handleClear} size={'small'} color={theme.colors.NEU_600} />}
        {...controlledProps}
      />
    </TextFieldWrapper>
  );
};

SearchBar.displayName = 'SearchBar'

export default SearchBar;
